import React from "react";
import { Link } from "react-router-dom";
import Back from "shared/assets/images/svg/back_blue.svg";
import StepWizard from "react-step-wizard";
import CompanyLocation from "auth/signUp/signup-customer/companyLocation";
import { CompanyInfo } from "auth/signUp/signup-customer/companyInfo";
import { useTranslation } from "react-i18next";

const SignupCustomer = () => {
  const {t} = useTranslation();
  return (
    <div className="signup">
      <div className="container">
        <div className="page-header">
          <div className="header-info">
            <Link to="/">
              <img src={Back} alt="" />
            </Link>
            <h1 className="title">{t('signup.title')}</h1>
          </div>
        </div>
        <hr className="hr" />

        <StepWizard transitions={{}}>
          <CompanyInfo />
          <CompanyLocation />
        </StepWizard>
      </div>
    </div>
  );
};

export default SignupCustomer;
